import styled from "styled-components"

export const LowerPictureDiv = styled.div`
/* display:flex; */
/* flex-direction:row; */
/* justify-content:center; */

    img{
        width: 100%;
        border-radius:30px;
    }
    h4{
        color: #000000;
    }
    p{
        color: rgba(0, 0, 0, 0.8);
    }


`